import React, { createContext, useContext, useState } from 'react';

const HighlightContext = createContext();

export const HighlightProvider = ({ children }) => {
  const [highlight, setHighlight] = useState(false);

  const toggleHighlight = () => {
    setHighlight(!highlight);
    setTimeout(() => {
      setHighlight(false);
  }, 1000);
  };

  return (
    <HighlightContext.Provider value={{ highlight, toggleHighlight }}>
      {children}
    </HighlightContext.Provider>
  );
};

export const useHighlight = () => {
  return useContext(HighlightContext);
};